module.exports = __webpack_public_path__ + "img/burger-king.5de70a2a.png";